// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { PageViewData } from '../Interfaces/Contracts/Generated/PageViewData';
import { DataSanitizer } from './Common/DataSanitizer';
import { FieldType } from '../Enums';
import { Util } from '../Util';
var PageView = /** @class */ (function (_super) {
    __extends(PageView, _super);
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageView(logger, name, url, durationMs, properties, measurements, id) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: FieldType.Required,
            name: FieldType.Default,
            url: FieldType.Default,
            duration: FieldType.Default,
            properties: FieldType.Default,
            measurements: FieldType.Default,
            id: FieldType.Default
        };
        _this.id = DataSanitizer.sanitizeId(logger, id);
        _this.url = DataSanitizer.sanitizeUrl(logger, url);
        _this.name = DataSanitizer.sanitizeString(logger, name) || Util.NotSpecified;
        if (!isNaN(durationMs)) {
            _this.duration = Util.msToTimeSpan(durationMs);
        }
        _this.properties = DataSanitizer.sanitizeProperties(logger, properties);
        _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
        return _this;
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}(PageViewData));
export { PageView };
//# sourceMappingURL=PageView.js.map